module.exports = __webpack_public_path__ + "static/media/voiture_03_thumb_hover.31d44509.png";